
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.18166 24.8267C8.25999 24.8267 7.38499 24.605 6.61499 24.1617C4.79499 23.1117 3.79166 20.9767 3.79166 18.165V9.84667C3.79166 7.02334 4.79499 4.90001 6.61499 3.85001C8.43499 2.80001 10.78 2.99834 13.23 4.41001L20.4283 8.56334C22.8667 9.97501 24.22 11.9117 24.22 14.0117C24.22 16.1117 22.8783 18.0483 20.4283 19.46L13.23 23.6133C11.8183 24.4183 10.4417 24.8267 9.18166 24.8267ZM9.18166 4.92334C8.55166 4.92334 7.99166 5.06334 7.48999 5.35501C6.22999 6.07834 5.54166 7.67667 5.54166 9.84667V18.1533C5.54166 20.3233 6.22999 21.91 7.48999 22.645C8.74999 23.38 10.4767 23.17 12.355 22.085L19.5533 17.9317C21.4317 16.8467 22.47 15.4583 22.47 14C22.47 12.5417 21.4317 11.1533 19.5533 10.0683L12.355 5.91501C11.2117 5.26167 10.1383 4.92334 9.18166 4.92334Z","fill":"currentColor"}})])
          )
        }
      }
    